import { render, staticRenderFns } from "./AllRatingsModal.vue?vue&type=template&id=4e9ea534&"
import script from "./AllRatingsModal.vue?vue&type=script&lang=ts&"
export * from "./AllRatingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports